var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 2.2346C0 2.2346 6.0372 5.65813 7.209 5.65813C8.4372 5.65813 14.409 2.30001 14.409 2.30001L14.4186 1.69999C14.4186 1.0376 13.881 0.5 13.2168 0.5H1.2012C0.5376 0.5 0 1.0376 0 1.69999V2.2346ZM14.409 4.1C14.409 4.1 8.4936 7.30814 7.209 7.30814C6.03724 7.30814 0.00946753 4.10025 0.00959996 4.1L0 11.3C0 11.9624 0.5382 12.5 1.2012 12.5H13.2168C13.881 12.5 14.4186 11.9624 14.4186 11.3L14.409 4.1Z"}));
}

Mail.defaultProps = {"width":"16","height":"16","viewBox":"0 0 15 13","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
